export default class HeaderAnswerTranslationItem {
    fetchKey: string;
    title: string | null;
    description: string | null;
    headerText: string | null;
    
    constructor(fetchKey: string, title: string | null, description: string | null, headerText: string | null) {
        this.fetchKey = fetchKey;
        this.title = title;
        this.description = description;
        this.headerText = headerText;
    }
}

export interface HeaderAnswerTranslationItemProperties {
    headerAnswerTranslationItem : HeaderAnswerTranslationItem | undefined;
}